// Original connected-region puzzles. Regenerate with npm run generate:puzzles.
export const PUZZLES = [
  {
    id: "easy-01",
    difficulty: "easy",
    size: 5,
    regions: [
      1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 1, 1, 2, 0, 3, 1, 4, 2, 3, 3, 1, 4, 4, 4, 3,
    ],
    solution: [3, 5, 12, 19, 21],
    givens: [3],
  },
  {
    id: "easy-02",
    difficulty: "easy",
    size: 5,
    regions: [
      1, 1, 0, 0, 0, 1, 1, 1, 0, 2, 3, 3, 1, 2, 2, 3, 3, 3, 2, 4, 3, 3, 3, 3, 4,
    ],
    solution: [2, 5, 13, 16, 24],
    givens: [2],
  },
  {
    id: "easy-03",
    difficulty: "easy",
    size: 5,
    regions: [
      0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 2, 2, 1, 1, 4, 4, 3, 3, 3, 4, 4, 4, 4, 3,
    ],
    solution: [0, 8, 11, 19, 22],
    givens: [0],
  },
  {
    id: "easy-04",
    difficulty: "easy",
    size: 5,
    regions: [
      1, 1, 2, 2, 0, 3, 1, 2, 2, 0, 3, 4, 4, 2, 2, 3, 4, 2, 2, 2, 3, 4, 4, 4, 2,
    ],
    solution: [4, 6, 13, 15, 22],
    givens: [4],
  },
  {
    id: "easy-05",
    difficulty: "easy",
    size: 5,
    regions: [
      0, 0, 0, 1, 1, 0, 2, 0, 1, 1, 3, 2, 2, 2, 1, 3, 3, 3, 3, 4, 3, 4, 4, 4, 4,
    ],
    solution: [1, 9, 12, 15, 23],
    givens: [1],
  },
  {
    id: "easy-06",
    difficulty: "easy",
    size: 5,
    regions: [
      1, 1, 0, 0, 0, 1, 1, 2, 0, 0, 4, 1, 2, 0, 0, 4, 1, 4, 3, 3, 4, 4, 4, 4, 4,
    ],
    solution: [3, 5, 12, 19, 21],
    givens: [3],
  },
  {
    id: "easy-07",
    difficulty: "easy",
    size: 5,
    regions: [
      0, 0, 0, 2, 2, 0, 1, 1, 2, 2, 3, 3, 3, 2, 2, 3, 3, 3, 4, 4, 3, 3, 4, 4, 4,
    ],
    solution: [0, 7, 14, 16, 23],
    givens: [0],
  },
  {
    id: "easy-08",
    difficulty: "easy",
    size: 5,
    regions: [
      0, 0, 0, 0, 0, 1, 1, 2, 2, 0, 1, 1, 2, 2, 0, 3, 1, 2, 2, 2, 3, 3, 4, 4, 2,
    ],
    solution: [4, 6, 13, 15, 22],
    givens: [4],
  },
  {
    id: "easy-09",
    difficulty: "easy",
    size: 5,
    regions: [
      0, 1, 2, 2, 2, 0, 1, 1, 2, 2, 0, 3, 1, 2, 2, 3, 3, 4, 4, 2, 3, 4, 4, 4, 4,
    ],
    solution: [0, 7, 14, 16, 23],
    givens: [0],
  },
  {
    id: "easy-10",
    difficulty: "easy",
    size: 5,
    regions: [
      0, 0, 0, 0, 0, 0, 2, 2, 1, 1, 0, 2, 2, 2, 2, 2, 2, 4, 3, 3, 2, 4, 4, 3, 3,
    ],
    solution: [0, 8, 11, 19, 22],
    givens: [0],
  },
  {
    id: "easy-11",
    difficulty: "easy",
    size: 5,
    regions: [
      1, 1, 1, 0, 0, 1, 1, 1, 2, 0, 1, 1, 4, 2, 0, 3, 4, 4, 2, 0, 3, 3, 4, 4, 0,
    ],
    solution: [4, 6, 13, 15, 22],
    givens: [4],
  },
  {
    id: "easy-12",
    difficulty: "easy",
    size: 5,
    regions: [
      4, 0, 0, 0, 0, 4, 4, 1, 1, 0, 2, 4, 3, 3, 3, 2, 4, 3, 3, 3, 2, 4, 3, 3, 3,
    ],
    solution: [4, 7, 10, 18, 21],
    givens: [4],
  },
  {
    id: "medium-01",
    difficulty: "medium",
    size: 6,
    regions: [
      1, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 3, 2, 2, 2, 1, 1, 3, 3, 3, 5, 1, 1,
      3, 4, 4, 5, 5, 3, 3, 3, 5, 5, 5,
    ],
    solution: [2, 6, 16, 19, 27, 35],
    givens: [],
  },
  {
    id: "medium-02",
    difficulty: "medium",
    size: 6,
    regions: [
      0, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 2, 2, 3, 5, 4, 1, 3, 3, 3, 5, 4, 4, 3,
      3, 3, 5, 4, 4, 3, 3, 5, 5, 4, 4,
    ],
    solution: [1, 10, 12, 20, 29, 33],
    givens: [],
  },
  {
    id: "medium-03",
    difficulty: "medium",
    size: 6,
    regions: [
      1, 1, 1, 0, 0, 0, 1, 1, 1, 0, 0, 0, 1, 1, 1, 2, 2, 0, 1, 3, 3, 3, 0, 0, 4,
      3, 3, 3, 3, 3, 4, 4, 5, 5, 3, 3,
    ],
    solution: [5, 7, 16, 20, 24, 33],
    givens: [],
  },
  {
    id: "medium-04",
    difficulty: "medium",
    size: 6,
    regions: [
      1, 1, 0, 0, 0, 0, 4, 1, 2, 2, 0, 0, 4, 2, 2, 2, 2, 0, 4, 4, 3, 3, 3, 3, 5,
      4, 4, 3, 3, 3, 5, 3, 3, 3, 3, 3,
    ],
    solution: [4, 7, 15, 23, 26, 30],
    givens: [],
  },
  {
    id: "medium-05",
    difficulty: "medium",
    size: 6,
    regions: [
      0, 0, 0, 0, 1, 1, 3, 3, 2, 0, 0, 1, 3, 2, 2, 0, 1, 1, 3, 3, 3, 4, 4, 1, 5,
      3, 5, 4, 4, 4, 5, 5, 5, 4, 4, 4,
    ],
    solution: [3, 11, 14, 18, 28, 31],
    givens: [],
  },
  {
    id: "medium-06",
    difficulty: "medium",
    size: 6,
    regions: [
      0, 0, 0, 0, 0, 0, 2, 2, 1, 1, 1, 0, 2, 2, 2, 1, 1, 0, 2, 2, 3, 3, 3, 3, 2,
      2, 3, 5, 4, 3, 5, 5, 5, 5, 4, 4,
    ],
    solution: [5, 9, 12, 20, 28, 31],
    givens: [],
  },
  {
    id: "medium-07",
    difficulty: "medium",
    size: 6,
    regions: [
      1, 1, 1, 1, 2, 0, 1, 1, 1, 1, 2, 0, 4, 1, 3, 2, 2, 2, 4, 4, 3, 2, 5, 5, 4,
      4, 5, 5, 5, 5, 4, 4, 4, 5, 5, 5,
    ],
    solution: [5, 7, 16, 20, 24, 33],
    givens: [],
  },
  {
    id: "medium-08",
    difficulty: "medium",
    size: 6,
    regions: [
      1, 1, 1, 1, 0, 0, 2, 2, 1, 1, 3, 3, 2, 2, 1, 3, 3, 3, 2, 2, 2, 3, 3, 3, 5,
      2, 5, 3, 4, 4, 5, 5, 5, 3, 4, 4,
    ],
    solution: [4, 8, 12, 21, 29, 31],
    givens: [],
  },
  {
    id: "medium-09",
    difficulty: "medium",
    size: 6,
    regions: [
      1, 0, 0, 2, 3, 3, 1, 0, 0, 2, 3, 3, 0, 0, 2, 2, 3, 3, 4, 4, 4, 3, 3, 3, 4,
      4, 5, 5, 5, 5, 4, 4, 5, 5, 5, 5,
    ],
    solution: [2, 6, 15, 23, 25, 34],
    givens: [],
  },
  {
    id: "medium-10",
    difficulty: "medium",
    size: 6,
    regions: [
      3, 3, 2, 0, 0, 0, 3, 3, 2, 0, 1, 1, 3, 3, 2, 2, 2, 5, 3, 3, 3, 2, 4, 5, 3,
      5, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5,
    ],
    solution: [3, 11, 14, 18, 28, 31],
    givens: [],
  },
  {
    id: "medium-11",
    difficulty: "medium",
    size: 6,
    regions: [
      1, 1, 1, 0, 0, 0, 2, 3, 1, 1, 1, 0, 2, 3, 3, 1, 1, 0, 2, 3, 3, 1, 1, 0, 3,
      3, 3, 3, 4, 0, 5, 5, 4, 4, 4, 4,
    ],
    solution: [5, 9, 12, 20, 28, 31],
    givens: [],
  },
  {
    id: "medium-12",
    difficulty: "medium",
    size: 6,
    regions: [
      2, 0, 0, 0, 5, 5, 2, 0, 1, 1, 5, 5, 2, 2, 3, 3, 3, 5, 2, 4, 3, 3, 3, 5, 4,
      4, 4, 3, 5, 5, 4, 4, 4, 5, 5, 5,
    ],
    solution: [1, 9, 12, 22, 26, 35],
    givens: [],
  },
  {
    id: "hard-01",
    difficulty: "hard",
    size: 7,
    regions: [
      0, 0, 1, 1, 1, 3, 3, 1, 1, 1, 1, 2, 3, 3, 1, 1, 2, 2, 2, 3, 3, 1, 5, 4, 2,
      3, 3, 3, 5, 5, 4, 4, 3, 3, 3, 5, 5, 4, 6, 6, 3, 6, 5, 5, 4, 4, 6, 6, 6,
    ],
    solution: [0, 9, 18, 27, 31, 36, 47],
    givens: [],
  },
  {
    id: "hard-02",
    difficulty: "hard",
    size: 7,
    regions: [
      0, 0, 0, 0, 0, 0, 1, 3, 0, 0, 0, 0, 1, 1, 3, 0, 0, 2, 0, 0, 1, 3, 3, 3, 2,
      1, 1, 1, 3, 3, 3, 1, 1, 4, 4, 3, 6, 5, 5, 1, 4, 4, 6, 6, 5, 5, 1, 4, 4,
    ],
    solution: [4, 13, 17, 22, 33, 37, 42],
    givens: [],
  },
  {
    id: "hard-03",
    difficulty: "hard",
    size: 7,
    regions: [
      0, 0, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 0, 2, 4, 4, 3, 1, 3, 2, 2, 4, 4,
      3, 3, 3, 2, 4, 4, 4, 3, 3, 6, 2, 2, 4, 4, 5, 5, 6, 2, 2, 4, 4, 6, 6, 6,
    ],
    solution: [0, 10, 15, 26, 30, 39, 48],
    givens: [],
  },
  {
    id: "hard-04",
    difficulty: "hard",
    size: 7,
    regions: [
      0, 0, 0, 0, 0, 0, 1, 0, 2, 2, 2, 2, 1, 1, 0, 2, 2, 2, 3, 1, 1, 0, 2, 4, 4,
      3, 1, 1, 0, 0, 4, 3, 3, 1, 5, 0, 0, 4, 3, 3, 1, 5, 4, 4, 4, 6, 6, 6, 5,
    ],
    solution: [0, 12, 15, 25, 30, 41, 45],
    givens: [],
  },
  {
    id: "hard-05",
    difficulty: "hard",
    size: 7,
    regions: [
      0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 2, 2, 0, 1, 1, 1, 1, 2, 3, 3, 1,
      1, 5, 5, 2, 6, 6, 4, 4, 4, 5, 6, 6, 4, 4, 6, 5, 5, 6, 6, 6, 6, 6, 5, 5,
    ],
    solution: [1, 12, 14, 23, 32, 41, 45],
    givens: [],
  },
  {
    id: "hard-06",
    difficulty: "hard",
    size: 7,
    regions: [
      0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 3, 3, 1, 2, 2, 1, 3, 3, 3, 1, 3, 3, 3,
      3, 4, 4, 5, 5, 3, 3, 4, 4, 4, 5, 5, 5, 6, 4, 4, 4, 5, 5, 5, 6, 6, 6, 6,
    ],
    solution: [0, 10, 15, 25, 34, 37, 47],
    givens: [],
  },
  {
    id: "hard-07",
    difficulty: "hard",
    size: 7,
    regions: [
      2, 4, 4, 4, 0, 0, 1, 2, 2, 2, 4, 1, 1, 1, 5, 2, 4, 4, 3, 3, 1, 5, 2, 4, 4,
      3, 3, 3, 5, 6, 6, 4, 4, 6, 3, 5, 6, 6, 6, 6, 6, 6, 5, 5, 6, 6, 6, 6, 6,
    ],
    solution: [4, 13, 15, 26, 31, 35, 44],
    givens: [],
  },
  {
    id: "hard-08",
    difficulty: "hard",
    size: 7,
    regions: [
      1, 2, 2, 0, 0, 0, 0, 1, 1, 2, 2, 0, 0, 0, 1, 2, 2, 0, 0, 0, 0, 1, 1, 2, 2,
      3, 3, 3, 5, 1, 5, 2, 3, 4, 4, 5, 5, 5, 5, 5, 5, 4, 5, 5, 5, 5, 5, 6, 6,
    ],
    solution: [3, 7, 16, 25, 34, 36, 47],
    givens: [],
  },
  {
    id: "hard-09",
    difficulty: "hard",
    size: 7,
    regions: [
      1, 0, 0, 2, 2, 2, 3, 1, 1, 0, 2, 2, 2, 3, 4, 4, 2, 2, 3, 3, 3, 4, 4, 2, 3,
      3, 3, 3, 4, 4, 5, 5, 3, 5, 3, 4, 4, 4, 5, 5, 5, 5, 4, 4, 4, 6, 6, 6, 5,
    ],
    solution: [2, 7, 17, 26, 29, 41, 46],
    givens: [],
  },
  {
    id: "hard-10",
    difficulty: "hard",
    size: 7,
    regions: [
      1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 0, 1, 1, 1, 2, 2, 2, 0, 3, 3, 3, 2,
      2, 2, 2, 4, 4, 3, 3, 3, 2, 2, 3, 3, 3, 5, 5, 5, 5, 6, 6, 6, 5, 5, 5, 5,
    ],
    solution: [6, 10, 19, 23, 28, 39, 43],
    givens: [],
  },
  {
    id: "hard-11",
    difficulty: "hard",
    size: 7,
    regions: [
      2, 2, 2, 1, 1, 0, 0, 2, 2, 2, 2, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 2, 4, 3, 3,
      3, 5, 3, 2, 4, 6, 6, 6, 5, 3, 6, 6, 6, 6, 5, 5, 5, 6, 6, 6, 6, 6, 6, 5,
    ],
    solution: [6, 11, 14, 24, 29, 40, 44],
    givens: [],
  },
  {
    id: "hard-12",
    difficulty: "hard",
    size: 7,
    regions: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 2, 0, 0, 1, 1, 1, 1, 2, 2, 1, 1,
      3, 3, 3, 2, 2, 1, 3, 3, 3, 4, 5, 5, 5, 5, 3, 6, 4, 3, 3, 3, 3, 3, 6, 6,
    ],
    solution: [1, 10, 14, 25, 34, 37, 47],
    givens: [],
  },
  {
    id: "single-easy-01",
    difficulty: "easy",
    size: 5,
    regions: [
      0, 0, 0, 1, 2, 0, 0, 3, 1, 2, 0, 0, 1, 1, 1, 0, 1, 1, 1, 1, 4, 4, 4, 4, 4,
    ],
    solution: [4, 7, 10, 18, 21],
    givens: [],
  },
  {
    id: "single-easy-02",
    difficulty: "easy",
    size: 5,
    regions: [
      1, 1, 1, 1, 0, 2, 2, 1, 1, 1, 2, 4, 1, 1, 3, 2, 4, 4, 3, 3, 4, 4, 4, 3, 3,
    ],
    solution: [4, 7, 10, 18, 21],
    givens: [],
  },
  {
    id: "single-easy-03",
    difficulty: "easy",
    size: 5,
    regions: [
      1, 0, 0, 0, 0, 1, 1, 3, 0, 0, 1, 3, 3, 4, 2, 1, 3, 4, 4, 4, 1, 1, 4, 4, 4,
    ],
    solution: [2, 5, 14, 16, 23],
    givens: [],
  },
  {
    id: "single-easy-04",
    difficulty: "easy",
    size: 5,
    regions: [
      4, 0, 0, 0, 0, 4, 1, 0, 0, 0, 4, 4, 4, 0, 2, 3, 3, 4, 0, 2, 4, 4, 4, 4, 2,
    ],
    solution: [3, 6, 14, 15, 22],
    givens: [],
  },
  {
    id: "single-medium-01",
    difficulty: "medium",
    size: 6,
    regions: [
      1, 1, 1, 1, 1, 0, 1, 1, 1, 0, 0, 0, 4, 1, 1, 2, 2, 0, 4, 4, 3, 2, 2, 2, 4,
      4, 4, 5, 5, 5, 4, 4, 5, 5, 5, 5,
    ],
    solution: [5, 7, 16, 20, 24, 33],
    givens: [],
  },
  {
    id: "single-medium-02",
    difficulty: "medium",
    size: 6,
    regions: [
      4, 1, 1, 1, 0, 0, 4, 1, 1, 1, 2, 0, 4, 1, 2, 2, 2, 2, 4, 1, 2, 2, 5, 3, 4,
      4, 4, 5, 5, 5, 4, 5, 5, 5, 5, 5,
    ],
    solution: [4, 7, 15, 23, 24, 32],
    givens: [],
  },
  {
    id: "single-medium-03",
    difficulty: "medium",
    size: 6,
    regions: [
      0, 0, 0, 0, 1, 1, 0, 2, 0, 0, 0, 1, 2, 2, 2, 3, 3, 3, 2, 2, 3, 3, 5, 5, 4,
      2, 3, 3, 5, 5, 2, 2, 5, 5, 5, 5,
    ],
    solution: [2, 11, 13, 21, 24, 34],
    givens: [],
  },
  {
    id: "single-medium-04",
    difficulty: "medium",
    size: 6,
    regions: [
      0, 2, 1, 1, 1, 3, 2, 2, 1, 1, 3, 3, 2, 2, 4, 1, 1, 3, 2, 2, 4, 3, 3, 3, 4,
      4, 4, 4, 5, 3, 5, 5, 5, 5, 5, 3,
    ],
    solution: [0, 9, 13, 23, 26, 34],
    givens: [],
  },
  {
    id: "single-hard-01",
    difficulty: "hard",
    size: 7,
    regions: [
      0, 0, 0, 1, 1, 1, 1, 0, 1, 1, 1, 2, 2, 1, 0, 3, 1, 2, 2, 2, 2, 0, 3, 3, 2,
      2, 4, 6, 0, 0, 3, 6, 6, 4, 6, 0, 0, 3, 5, 6, 6, 6, 0, 3, 3, 3, 6, 6, 6,
    ],
    solution: [0, 9, 18, 22, 33, 38, 48],
    givens: [],
  },
  {
    id: "single-hard-02",
    difficulty: "hard",
    size: 7,
    regions: [
      0, 1, 1, 1, 1, 1, 1, 1, 1, 3, 3, 1, 1, 1, 3, 3, 3, 3, 4, 2, 2, 3, 3, 3, 4,
      4, 2, 2, 6, 3, 3, 4, 4, 4, 4, 6, 5, 5, 5, 5, 4, 4, 6, 6, 5, 5, 5, 4, 4,
    ],
    solution: [0, 11, 20, 23, 33, 38, 43],
    givens: [],
  },
  {
    id: "single-hard-03",
    difficulty: "hard",
    size: 7,
    regions: [
      1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 3, 2, 0, 0, 1, 3, 3, 3,
      4, 0, 0, 3, 3, 3, 4, 4, 4, 5, 3, 3, 3, 4, 6, 4, 5, 3, 3, 6, 6, 6, 6, 5,
    ],
    solution: [5, 7, 18, 22, 31, 41, 44],
    givens: [],
  },
  {
    id: "single-hard-04",
    difficulty: "hard",
    size: 7,
    regions: [
      1, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 3, 3, 3, 2, 1, 5, 1, 3,
      3, 3, 4, 5, 5, 1, 3, 4, 4, 4, 5, 5, 5, 3, 6, 4, 4, 5, 5, 5, 5, 6, 6, 6,
    ],
    solution: [2, 7, 20, 24, 33, 36, 46],
    givens: [],
  },
];
